import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { Copy, Check, Tag } from 'lucide-react';
import { toast } from 'sonner';

export default function DiscountBanner({ variant = 'inline' }) {
  const { user } = useAuth();
  const [codes, setCodes] = useState([]);
  const [copied, setCopied] = useState(null);

  useEffect(() => {
    if (!user) return;
    api.get('/discount-codes').then(r => setCodes(r.data)).catch(() => {});
  }, [user]);

  if (!user || codes.length === 0) return null;
  const c = codes[0];

  const copy = async () => {
    await navigator.clipboard.writeText(c.code);
    setCopied(c.code);
    toast.success('Código copiado');
    setTimeout(() => setCopied(null), 2200);
  };

  const expires = new Date(c.expires_at).toLocaleDateString('es-ES', { day: '2-digit', month: 'long', year: 'numeric' });

  if (variant === 'hero') {
    return (
      <div className="relative bg-stilo-terra text-stilo-bg p-8 md:p-10 grid md:grid-cols-12 gap-6 items-center" data-testid="discount-banner">
        <div className="md:col-span-7">
          <p className="overline text-stilo-bg/80">Tu regalo de bienvenida</p>
          <h3 className="font-serif text-3xl md:text-4xl mt-2 leading-tight">10% de descuento en Stilo Decor</h3>
          <p className="text-stilo-bg/85 mt-3 text-sm">Por confiar en una asesoría conmigo. Válido hasta el {expires}.</p>
        </div>
        <div className="md:col-span-5 flex flex-col items-start md:items-end gap-3">
          <code className="font-mono text-2xl md:text-3xl tracking-widest bg-stilo-bg/10 px-5 py-3 border border-stilo-bg/30" data-testid="discount-code">{c.code}</code>
          <button onClick={copy} className="inline-flex items-center gap-2 text-sm tracking-widest uppercase border-b border-stilo-bg pb-1 hover:text-stilo-ink transition-colors" data-testid="discount-copy">
            {copied === c.code ? <><Check className="w-4 h-4" strokeWidth={1.5} /> Copiado</> : <><Copy className="w-4 h-4" strokeWidth={1.5} /> Copiar código</>}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 border border-stilo-terra/30 bg-stilo-terra/5 px-6 py-4" data-testid="discount-banner">
      <div className="flex items-start gap-3">
        <Tag className="w-5 h-5 text-stilo-terra mt-0.5" strokeWidth={1.5} />
        <div>
          <p className="text-stilo-ink"><span className="font-medium">10% de descuento</span> en Stilo Decor con tu código</p>
          <p className="text-xs text-stilo-ink2 mt-0.5">Caduca el {expires} · un solo uso</p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <code className="font-mono text-base tracking-widest bg-stilo-bg px-4 py-2 border border-stilo-ink/15" data-testid="discount-code">{c.code}</code>
        <button onClick={copy} className="text-stilo-ink2 hover:text-stilo-ink p-2" title="Copiar" data-testid="discount-copy">
          {copied === c.code ? <Check className="w-4 h-4" strokeWidth={1.5} /> : <Copy className="w-4 h-4" strokeWidth={1.5} />}
        </button>
      </div>
    </div>
  );
}
